export enum  ProfessionalSector{

    AUTONOMOUS = 'AUTONOMOUS' ,

    PUBLIC = 'PUBLIC' ,

    MIXED = 'MIXED',

    PRIVATE = 'PRIVATE'
}